import { useEffect, useState } from 'react';
import useAuth from '../../hooks/useAuth';
import CustomSnackbar from '../@extended/CustomSnackbar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const OverDueWarning = () => {
  const [isValidPath, setIsValidPath] = useState(false);
  const [isOverDue, setIsOverDue] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  useEffect(() => {
    const tmpPath = location.pathname;
    if (
      tmpPath === '/' ||
      tmpPath.includes('/login') ||
      tmpPath.includes('/register') ||
      tmpPath.includes('/forgot-password') ||
      tmpPath.includes('/check-mail') ||
      tmpPath.includes('/welcome') ||
      tmpPath.includes('/account-settings/billing')
    ) {
      setIsValidPath(false);
    } else {
      setIsValidPath(true);
    }
  }, [location]);

  const { user } = useAuth();

  useEffect(() => {
    setIsOverDue(user?.isOverDueUser || false);
  }, [user]);

  return (
    <>
      {isValidPath && isOverDue && (
        <CustomSnackbar
          action={true}
          duration={-1}
          open={true}
          message={
            <Grid display={'flex'}>
              <Typography color={theme.palette.common.white} sx={{ lineHeight: '48px', verticalAlign: 'middle', pl: isMobile ? 3 : 4 }}>
                Subscription renewal
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography color={theme.palette.error.main} sx={{ lineHeight: '48px', verticalAlign: 'middle' }}>
                failed
              </Typography>
            </Grid>
          }
          buttonName={'Renew'}
          handleButton={() => {
            navigate('/account-settings/billing?openModal=true', { replace: false });
          }}
          alert={{
            color: 'error'
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transition={'SlideUp'}
        />
      )}
    </>
  );
};

export default OverDueWarning;
